/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Fuel type
 */
export enum FuelType {
    PETROL = 'petrol',
    DIESEL = 'diesel',
    HVO = 'hvo',
    E85 = 'e85',
    LPG = 'lpg',
    CNG = 'cng',
    ELECTRICITY = 'electricity',
    HYDROGEN = 'hydrogen',
    ADBLUE = 'adblue',
}
